/* You can add global styles to this file, and also import other style files */
@import "assets/scss/common/custom";
@import '~leaflet/dist/leaflet.css'